module.exports = __webpack_public_path__ + "static/img/Collection Page.3f5db964.svg";